<template>
  <div class="qrcode">
    <div id="reader"></div>
  </div>
</template>

<script>
import { Html5Qrcode } from "html5-qrcode";

export default {
  components: {
  },
  data () {
  },
  created() {
    this.getCameras()
  },
  beforeDestroy() {
    this.stop();
    console.log("关闭")
  },
  methods: {
    getCameras() {
      Html5Qrcode.getCameras()
        .then((devices) => {
          if (devices && devices.length) {
            this.html5QrCode = new Html5Qrcode("reader");
            this.start();
          }
        })
    },
    start() {
      this.html5QrCode
        .start(
          { facingMode: "environment" },
          {
            fps: 2,
            qrbox: { width: 300, height: 50 }
          },
          (decodedText, decodedResult) => {
            this.$emit("ok", decodedText)
            console.log(decodedText)
          }
        ).catch((err) => {
          this.$emit("err", err)
        })
    },
    stop() {
      this.html5QrCode.stop().then((ignore) => {
        console.log("QR Code scanning stopped.");
      })
    }
  }
}
</script>

<style scoped>
.qrcode {
  position: relative;
  height: 100%;
  width: 100%;
  background: rgba($color: #000000, $alpha: 0.48);
}

#reader {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
</style>
